<!-- 首页 -->
<template>
  <div>
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1" ref="chooseMethod" @click="loseFocus()"></HeaderNav>
    <!-- banner -->
    <Banner :banner="bannerList" ></Banner>
    <div class="part1 container">
      <div class="title">明星产品</div>
      <div class="part1_cont part_cont">
        <ul>
          <li>
            <a href="/plus/view.php?aid=19">
              <div class="li_img"><img src="static/picture/1-200q41055360-l.jpg"></div>
              <div class="li_text">
                <h1>Luara肌底液</h1>
                <p>多重修护焕亮  拥有质感美肌</p>
              </div>
            </a>`
          <li>
            <a href="/plus/view.php?aid=18">
              <div class="li_img"><img src="static/picture/1-200q41054040-l.jpg"></div>
              <div class="li_text">
                <h1>Luara佐伯水</h1>
                <p>深层滋润 持久保湿</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="part2 slideGroup">
		<ul class="parHd">
			<li class="css_style on" @click="linkOther(0)">luara</li>
			<li class="css_style" @click="linkOther(1)">hoc time</li>
			<li class="css_style" @click="linkOther(2)">maesoul</li>
			<li class="css_style" @click="linkOther(3)">lewa</li>
			<li class="css_style" @click="linkOther(4)">SLIM BEAUTY LABO</li>
			<li class="css_style" @click="linkOther(5)">coming soon</li>
		</ul>
	  <div class="parBd">
		<!--1-->
		<div class="slideBox" style="display: none;">
			<a class="sPrev" href="javascript:void(0)"></a>
			<ul>
				<li>
					<a href="/plus/view.php?aid=58">
						<img src="static/picture/1-210p9150s5l2.png">
						<h1>晶泽面霜<span>Face Cream</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=57">
						<img src="static/picture/1-210p9140gb36.png">
						<h1>晶泽精华<span>High Quality Essence</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=55">
						<img src="static/picture/1-210g2152i5532.jpg">
						<h1>隔离霜<span>Base Cream</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=50">
						<img src="static/picture/1-210319142439614.jpg">
						<h1>佐伯面霜<span>Chizu Cream</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=49">
						<img src="static/picture/1-210319141i6301.jpg">
						<h1>佐伯乳液<span>Chizu Emulsion</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=48">
						<img src="static/picture/1-2103191412123m.jpg">
						<h1>眼霜<span>Eye Cream</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=43">
						<img src="static/picture/1-21022011402bj.jpg">
						<h1>去角质霜<span>Gommage Cleansing</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=42">
						<img src="static/picture/1-21022011302i43.jpg">
						<h1>涂抹面膜<span>Moist Cream Pack</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=1">
						<img src="static/picture/1-200g4122121b0.jpg">
						<h1>肌底液<span>Repair Essence</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=17">
						<img src="static/picture/1-2009160uf0208.jpg">
						<h1>佐伯水<span>Chizu Lotion</span></h1>
					</a>
				</li>

			</ul>
			<a class="sNext" href="javascript:void(0)"></a>
		</div>
		<!--2-->
		<div class="slideBox" style="display: none;">
			<a class="sPrev" href="javascript:void(0)"></a>
			<ul>
				<li>
					<a href="/html/HOCTIME/20220224/70.html">
						<img src="static/picture/1-22022411225qr.png">
						<h1>面霜<span>CREAM</span></h1>
					</a>
				</li>
        <li>
					<a href="/html/HOCTIME/20220224/69.html">
						<img src="static/picture/1-220224112133326.png">
						<h1>洁面乳<span>CLEANSING FOAM</span></h1>
					</a>
				</li>
        <li>
					<a href="/html/HOCTIME/20220224/68.html">
						<img src="static/picture/1-220224111tx63.png">
						<h1>美容液<span>ESSENCE</span></h1>
					</a>
				</li>
        <li>
					<a href="/html/HOCTIME/20220224/67.html">
						<img src="static/picture/1-220224111i0942.png">
						<h1>乳液<span>EMULSION</span></h1>
					</a>
				</li>
        <li>
					<a href="/html/HOCTIME/20220224/66.html">
						<img src="static/picture/1-220224111152615.png">
						<h1>化妆水<span>LOTION</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=46">
						<img src="static/picture/1-211130141515n0.png">
						<h1>保湿凝胶霜<span>MOIST GEL</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=41">
						<img src="static/picture/1-211130142ub29.png">
						<h1>颈霜<span>NECK CREAM</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=40">
						<img src="static/picture/1-21113014320t44.png">
						<h1>面膜<span>SHEET MASK</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=16">
						<img src="static/picture/1-21113014351m95.png">
						<h1>卸妆凝胶<span>CLEANSING GEL</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=15">
						<img src="static/picture/1-211130143p2w1.png">
						<h1>浓缩精粹眼霜<span>CONCENTRATE EYE CREAM</span></h1>
					</a>
				</li>

			</ul>
			<a class="sNext" href="javascript:void(0)"></a>
		</div>
		<!--3-->
		<div class="slideBox" style="display: none;">
			<a class="sPrev" href="javascript:void(0)"></a>
			<ul>
                <li><a href="/plus/list.php?tid=3"><img src="static/picture/2.jpg"></a></li>
                <li><a href="/plus/list.php?tid=3"><img src="static/picture/3.jpg"></a></li>
                <li><a href="/plus/list.php?tid=3"><img src="static/picture/4.jpg"></a></li>
                <li><a href="/plus/list.php?tid=3"><img src="static/picture/5.jpg"></a></li>
                <li><a href="/plus/list.php?tid=3"><img src="static/picture/6.jpg"></a></li>
                <li><a href="/plus/list.php?tid=3"><img src="static/picture/7.jpg"></a></li>
                <li><a href="/plus/list.php?tid=3"><img src="static/picture/8.jpg"></a></li>
                <li><a href="/plus/list.php?tid=3"><img src="static/picture/9.jpg"></a></li>
			</ul>
			<a class="sNext" href="javascript:void(0)"></a>
		</div>       
		<!--4-->
		<div class="slideBox" style="display: none;">
			<a class="sPrev" href="javascript:void(0)"></a>
			<ul>
				<li>
					<a href="/plus/view.php?aid=56">
						<img src="static/picture/1-210g2153g3t6.png">
						<h1>清凝面膜<span>BLACK MASK</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=45">
						<img src="static/picture/1-210220152333248.jpg">
						<h1>LEWA面膜<span>MOIST MASK</span></h1>
					</a>
				</li>
        <li>
					<a href="/plus/view.php?aid=44">
						<img src="static/picture/1-210220152356345.jpg">
						<h1>LEWA精华<span>GRACE ESSENCE</span></h1>
					</a>
				</li>

			</ul>
			<a class="sNext" href="javascript:void(0)"></a>
		</div>       
		<!--5-->
		<div class="slideBox" style="display: none;">
			<a class="sPrev" href="javascript:void(0)"></a>
			<ul>
				<li><a href="/plus/list.php?tid=11"><img src="static/picture/12.jpg"></a></li>
				<li><a href="/plus/list.php?tid=11"><img src="static/picture/13.jpg"></a></li>
				<li><a href="/plus/list.php?tid=11"><img src="static/picture/14.jpg"></a></li>
				<li><a href="/plus/list.php?tid=11"><img src="static/picture/15.jpg"></a></li>
				<li><a href="/plus/list.php?tid=11"><img src="static/picture/16.jpg"></a></li>
				<li><a href="/plus/list.php?tid=11"><img src="static/picture/17.jpg"></a></li>
			</ul>
			<a class="sNext" href="javascript:void(0)"></a>
		</div>       
		<!--6-->
		<div class="slideBox" style="display: none;">
			<a class="sPrev" href="javascript:void(0)"></a>
			<ul>
				<li><a><img src="static/picture/1.jpg"></a></li>
				<li><a><img src="static/picture/1.jpg"></a></li>
				<li><a><img src="static/picture/1.jpg"></a></li>
				<li><a><img src="static/picture/1.jpg"></a></li>
				<li><a><img src="static/picture/1.jpg"></a></li>
				<li><a><img src="static/picture/1.jpg"></a></li>
			</ul>
			<a class="sNext" href="javascript:void(0)"></a>
		</div>
	</div>
</div>
<div class="part3 container">
	<div class="title">打造不输给年龄的护肤品<br>提高肌肤原本的通透感、光泽和弹性</div>
	
	<div class="part1_cont part_cont">
		<ul>
			<li>
				<div class="li_img"><img src="static/picture/img_544_727_3.jpg"></div>
			</li>
			<li>
				<div class="li_img"><img src="static/picture/img_544_727_4.jpg"></div>
			</li>
		</ul>
	</div>
</div>



<div class="part4">
	<div class="title">新资讯</div>
	
	<div class="part4_cont part_cont container">
		<ul>
		<a @click="linkSaleNews">
			<li>
				<div class="li_img"><img src="static/picture/1-21121014213tx.jpg"></div>
				<div class="li_text">
					<p>Super us，Beyond us</p>
				</div>
			</li>
			</a>
		<a @click="linkSaleNews">
			<li>
				<div class="li_img"><img src="static/picture/1-2111121fr4308.jpg"></div>
				<div class="li_text">
					<p>进博会LEWA魅力出圈</p>
				</div>
			</li>
			</a>
		<a @click="linkSaleNews">
			<li>
				<div class="li_img"><img src="static/picture/1-2111121f42d95.jpg"></div>
				<div class="li_text">
					<p>美肤新势力“耀”你好看</p>
				</div>
			</li>
			</a>

		</ul>
	</div>
</div>



<div class="part5 container" >
	<a @click="linkAllSale">查询门店</a>
	<!--<div class="part5_search">
		<form class="search_form" action="" method="post">
			<input class="button" type="submit" value="" id="">
			<input class="" type="text" placeholder="门店查询">
		</form>
	</div>-->
	<img src="static/picture/part5_img.jpg">
</div>

    <!-- 页脚组件 -->
    <FooterNav ></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../components/HeaderNav';
import FooterNav from '../components/FooterNav';
import Banner from '../components/Banner';
import Banners from '../components/Banners';
import RightNav from '../components/RightNav.vue';
import SanTable from '../components/SanTable.vue';
import { apiGetIndex } from '../api/index.js';
import { getHomeData } from '../api/index.js';
import { getSelect } from '../api/index.js';
import { apiGetCity, apiSunmitOperateIntent, apigetSetting } from '../api/login.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    Banners: Banners,
    RightNav: RightNav,
    SanTable: SanTable
  },
  name: '',
  data() {
    return {
      selected: 'qing',
      inputMoney: '',
      inputName: '',
      inputPhone: '',
      login: false, //是否登录
      userInfo: [], //是否登录--用户信息
      showk: true,
      isChange: 0,
      isSelect: '',
      bannerList: [
        {url:'static/picture/1-210q011124c39.jpg'},
        {url:'static/picture/1-210q0111344329.jpg'},
        {url:'static/picture/1-211130135go01.jpg'},
		{url:'static/picture/1-21113013532n05.jpg'},
		{url:'static/picture/banner3.jpg'},
		{url:'static/picture/banner2.jpg'},
		{url:'static/picture/1-200z91350380-l.jpg'},
		{url:'static/picture/1-200z91350500-l.jpg'},
		{url:'static/picture/1-200z91351030-l.jpg'},
      ],
      shuju: {},
      one: '',
      name: '',
      phone: '',
      advertInfo: '',
      estateType: '',
      area: '',
      maskShow: false, //通知表单--是否打开
      houseName: '', //通知表单--房子名称
      whereFrom: '', //通知表单--来源
      sellId: '', //通知表单--销售顾问Id
      articleTitleList: [],
      bannerLists: [{ img: '../../static/pC/img (7).png' }],
      navList: [],
      saleList: [],
      itemList: [],
      activityList: [],
      value: '', //banner--搜索内容筛选公司、岗位
      nameInput: '', //banner--搜索内容
      hotsearch: [{ name: '远洋天赋' }, { name: '万科紫台' }, { name: '联发君樾府' }, { name: '首开融创榕耀之城' }], //banner--热门搜索
      detailList: [],
      selectList: [],
      hotList: [],
      openSelect: false,//下拉框
      pullDownList:[],//搜索 -- 下拉框内容

    };
  },
  created() {},
  mounted() {},
  methods: {
    //跳转到企业详情
    hotSale(id) {
      this.$router.push({ path: '/jobIndex', query: { id: id } });
    },
    toActive(id) {
      this.$router.push({ path: '/jobDetail', query: { id: id } });
    },
    linkAllSale(id) {
      this.$router.push({ path: '/Address', query: {  } });
    },
    linkSaleNews() {
      this.$router.push({ path: '/News', query: {} });
    },
    linkSaleDetail(id) {
      this.$router.push({ path: '/jobDetail', query: {  } });
    },
	linkOther(id) {
		console.log(id)
		if(id==1){
			this.$router.push({ path: '/HOCTIME', query: { } });
		}
    },
    //跳转到新闻资讯详情
    linkNewDetail(id) {
      this.$router.push({ path: '/messageDetail', query: { id: id } });
    },

    //跳转到新闻资讯
    linkNew() {
      this.$router.push({ path: '/messageIndex', query: {} });
    }
  }
};
</script>
<style scoped>
.swiper-container {
  width: 100%;
}
/deep/ .el-input-group__append,
.el-input-group__prepend {
  background-color: #345c4e;
  color: #ffffff;
  border-radius: 10px;
  padding: 0 45px;
  font-size: 16px;
}
/deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 10px;
  border: 1px solid #a4a8bb;
  color: #606266;
  display: inline-block;
  font-size: 14px;
  height: 62px;
  line-height: 62px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 94%;
}
/deep/ .el-select-dropdown__list {
  list-style: none;
  padding: 10px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
/deep/ .el-select-dropdown__item.selected {
  color: #909399;
  font-weight: 400;
}

/*------------index.html  start----------------*/
.part1{
	overflow: hidden;
	margin: 0 auto 80px;
}
.part1_cont{
	overflow: hidden;
}
.part1_cont li{
	width: 48.65%;
	float: left;
	overflow: hidden;
	margin-right: 2.7%;
}
.part1_cont li:nth-child(2n){
	margin-right: 0;
}
.part_cont li .li_img{
	width: 100%;
	overflow: hidden;
}
.part_cont li .li_img img{
	width: 100%;
	display: block;
	margin: 0 auto;
	transition: all 0.3s ease-out 0s;
	-webkit-transition: all 0.3s ease-out 0s;
	-moz-transition: all 0.3s ease-out 0s;
	-o-transition: all 0.3s ease-out 0s;
}
.part_cont li .li_img:hover img{
	-webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
}
.part1_cont li .li_text{
	text-align: center;
	padding: 10px 20px;
	color: #000;
}
.part1_cont li .li_text h1{
	font-size: 22px;
	font-family: Font_Regular;
}
.part1_cont li .li_text p{
	font-size: 20px;
	font-family: Font_ExtraLight;
}
.part2{
	padding: 60px 0;
	overflow: hidden;
	border-top: 1px solid #000;
	border-bottom: 1px solid #000;
	position: relative;
}

.slidePro .hd {
	width: 100%;
}
.slidePro .hd ul{
	margin: 10px auto 60px;
	text-align: center;
}
.slidePro .hd li{
	width: 16.2%;
	display: inline-block;
	margin: 0;
	height: 80px;
	line-height: 80px;
	color: #383838;
	text-align: center;
	cursor: pointer;
	font-size: 18px;
	font-family: Font_Regular;
	text-transform: uppercase;
	position: relative;
	border-bottom: 3px solid #e6e6e6;
	white-space:nowrap;
}
.slidePro .hd li.on,
.slidePro .hd li:hover{
	border-bottom: 3px solid #000000;
}
.slidePro .hd li.on:before,
.slidePro .hd li:hover:before{
	content: '';
	display: block;
	position: absolute;
	bottom: -15px;
	left: 50%;
	margin-left: -17px;
	width: 0;
    height: 0;
    border-left: 17px solid transparent;
    border-right: 17px solid transparent;
    border-top: 12px solid #000;
    font-size: 0;
    line-height: 0;
}

.slidePro .bd {
	overflow: hidden;
	position: relative;
}
.slidePro .bd .cont{
	width: 100%;
	overflow: hidden;
	position: relative;
}
.slidePro .bd .cont_in{
	width: 23%;
	float: left;
	margin: 0 1%;
	text-align: center;
}
.slidePro .bd .cont_in img{
	max-width: 100%;
}
.slidePro .prev,
.slidePro .next {
	display: block;
    width: 58px;
    height: 64px;
	position: absolute;
	top: 50%;
	margin-top: -32px;
    cursor: pointer;
	z-index: 2;
}
.slidePro .prev {
	left: 0px;
    background: url(../../static/image/ann_l_1.jpg) no-repeat 0px 0px;
	background-size: contain;
}
.slidePro .next {
	right: 0px;
    background: url(../../static/image/ann_r_1.jpg) no-repeat 0px 0px;
	background-size: contain;
}


.slideGroup .parHd {
	margin: 10px auto 60px;
}
.slideGroup .parHd li {
	width: 16.2%;
	display: inline-block;
	margin: 0;
	height: 80px;
	line-height: 80px;
	color: #383838;
	text-align: center;
	cursor: pointer;
	font-size: 18px;
	font-family: Font_Regular;
	text-transform: uppercase;
	position: relative;
	border-bottom: 3px solid #e6e6e6;
	white-space: nowrap;
}
.slideGroup .parHd li.on,
.slideGroup .parHd li:hover {
	border-bottom: 3px solid #000000;
}
.slideGroup .parHd li.on:before,
.slideGroup .parHd li:hover:before {
	content: '';
	display: block;
	position: absolute;
	bottom: -15px;
	left: 50%;
	margin-left: -17px;
	width: 0;
	height: 0;
	border-left: 17px solid transparent;
	border-right: 17px solid transparent;
	border-top: 12px solid #000;
	font-size: 0;
	line-height: 0;
}
.slideGroup .slideBox {
	width: 100%;
	overflow: hidden;
	zoom: 1;
	position: relative;
}
.slideGroup .sPrev,
.slideGroup .sNext {
	position: absolute;
	top: 50%;
	margin-top: -32px;
	display: block;
	width: 58px;
	height: 64px;
	cursor: pointer;
	z-index: 2;
}
.slideGroup .sNext {
	right: 0px;
	background: url(../../static/image/ann_l_1.jpg) no-repeat 0px 0px;
	background-size: contain;
}
.slideGroup .sPrev {
	left: 0px;
	background: url(../../static/image/ann_l_1.jpg) no-repeat 0px 0px;
	background-size: contain;
}
.slideGroup .parBd {
	width: 100%;
	overflow: hidden;
}
.slideGroup .parBd ul {
	width: 100%;
	overflow: hidden;
}
.slideGroup .parBd ul li {
	width: 280px;
	margin: 0 20px;
	float: left;
	overflow: hidden;
	text-align: center;
	padding-bottom: 40px;
	position: relative;
}
.slideGroup .parBd ul li img {
	max-width: 100%;
}
.slideGroup .parBd ul li h1 {
	width: 100%;
	position: absolute;
	left: 0;
	bottom: 0;
	text-align: center;
	font-size: 14px;
	color: #3c3b3b;    
	line-height: 22px;
}
.slideGroup .parBd ul li h1 span {
	display: block;
	font-size: 15px;
	font-weight: normal;
}
.part3{
	overflow: hidden;
	margin: 0 auto 100px;
}
.part4{
	overflow: hidden;
	margin: 0 auto;
	background: #f6f6f6;
}
.part4 .title{
	margin: 45px auto;
}
.part4_cont{
	overflow: hidden;
}
.part4_cont li{
	width: 29%;
	float: left;
	overflow: hidden;
	margin-right: 3.5%;
}
.part4_cont li:nth-child(3n){
	margin-right: 0;
}
.part4_cont li .li_text{
	text-align: center;
	padding: 30px 20px 40px;
}
.part4_cont li .li_text p{
	font-size: 18px;
	letter-spacing: 2px;
	font-family: Font_Normal;
}
.part5{
	margin: 70px auto;
	overflow: hidden;
	position: relative;
}
.part5 a{
	width: 340px;
    text-align: center;
    height: 60px;
    line-height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -170px;
    margin-top: -30px;
    color: #fff;
    background: #000 url(../../static/image/search_btn.png) no-repeat 20px 50%;
    display: block;
}
.part5 a:hover{
    color: #fff;
}
.part5 img{
	max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/Index.vue